export const getQueryFromUrl = (query: string, url?: string | null) => {
  const urlParams = new URLSearchParams(
    url ? url.split('?')[1] : window.location.search
  );
  const value = urlParams.get(query);
  // if (value) {
  //   console.log(7, value);
  //   return decodeURIComponent(value);
  // }

  // console.log(11, value);
  return value;
};

// Add query param or update it if exists without touching other params
export const updateQueryParam = (key: string, value?: string | null) => {
  const searchParams = new URLSearchParams(window.location.search);

  if (!value) {
    // remove the query param
    searchParams.delete(key);
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${searchParams.toString()}`
    );
    return;
  }

  searchParams.set(key, value);
  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${searchParams.toString()}`
  );
};

// Add query param or update it if exists without touching other params
export const updateUrlQueryParam = (
  url: string,
  key: string,
  value?: string | null
) => {
  const searchParams = new URLSearchParams(url.split('?')[1]);

  if (!value) {
    // remove the query param
    searchParams.delete(key);
    return `${url.split('?')[0]}?${searchParams.toString()}`;
  }

  searchParams.set(key, value);
  return `${url.split('?')[0]}?${searchParams.toString()}`;
};

// Add query param or update it if exists without touching other params
export const updateUrlQueryParams = (
  url: string,
  params: {
    key: string;
    value?: string | null;
  }[]
) => {
  const searchParams = new URLSearchParams(url.split('?')[1]);

  params.forEach((param) => {
    if (!param.value) {
      // remove the query param
      searchParams.delete(param.key);
    } else {
      searchParams.set(param.key, param.value);
    }
  });

  return `${url.split('?')[0]}?${searchParams.toString()}`;
};

// append query param as redirectUrl
export function withRedirectUrl(url: string, redirectUrl?: string): string {
  if (!redirectUrl) {
    const originalRedirectUrl = getQueryFromUrl('redirectUrl');
    if (originalRedirectUrl) {
      if (url.includes('?')) {
        return `${url}${
          originalRedirectUrl
            ? `&redirectUrl=${encodeURIComponent(originalRedirectUrl)}`
            : ''
        }`;
      }

      return `${url}${
        originalRedirectUrl
          ? `?redirectUrl=${encodeURIComponent(originalRedirectUrl)}`
          : ''
      }`;
    }
  }

  if (url.includes('?')) {
    return `${url}${redirectUrl ? `&redirectUrl=${redirectUrl}` : ''}`;
  }

  return `${url}${redirectUrl ? `?redirectUrl=${redirectUrl}` : ''}`;
}
